import { render, staticRenderFns } from "./AllVideo.vue?vue&type=template&id=72e38e6a"
import script from "./AllVideo.vue?vue&type=script&lang=ts"
export * from "./AllVideo.vue?vue&type=script&lang=ts"
import style0 from "./AllVideo.vue?vue&type=style&index=0&id=72e38e6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports